import React, { useEffect, useMemo, useRef, useState } from 'react'
import Tooltip from '@groovehq/internal-design-system/lib/components/Tooltip/Tooltip'
import Checkbox from '@groovehq/internal-design-system/lib/components/Checkbox/Checkbox'
import { styles } from '../MultiSelectMenu/styles'

export default function Option({ id, name, checked }) {
  const [isItemTextOverflowing, setIsItemTextOverflowing] = useState(null)
  const itemTextRef = useRef(null)

  useEffect(() => {
    if (itemTextRef.current) {
      setIsItemTextOverflowing(
        itemTextRef.current.clientWidth < itemTextRef.current.scrollWidth
      )
    }
  }, [])

  const content = useMemo(
    () => (
      <div className="grui truncate" ref={itemTextRef}>
        {name}
      </div>
    ),
    [name]
  )

  return (
    <Checkbox css={styles.checkbox} truncate id={id} checked={checked} gap={16}>
      {isItemTextOverflowing ? (
        <Tooltip title={name} strategy="fixed" portal="#overlays">
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Checkbox>
  )
}
